import type { UserPermissions } from '../pages/users/types/permissions';

export type ClientProfileTabId = 'profile' | 'billing' | 'contacts';

/** Tabs always visible on the staff client profile page. */
const ALWAYS_VISIBLE: ClientProfileTabId[] = ['profile'];

export function getVisibleClientProfileTabs(
  permissions: Partial<UserPermissions>,
): ClientProfileTabId[] {
  const tabs: ClientProfileTabId[] = [...ALWAYS_VISIBLE];
  if (permissions.show_client_profile_billing_tab === true) {
    tabs.push('billing');
  }
  if (permissions.show_client_profile_contacts_tab === true) {
    tabs.push('contacts');
  }
  return tabs;
}

export function isClientProfileTabVisible(
  tab: string | null | undefined,
  permissions: Partial<UserPermissions>,
): tab is ClientProfileTabId {
  if (!tab) return false;
  return getVisibleClientProfileTabs(permissions).includes(tab as ClientProfileTabId);
}

export function resolveClientProfileTab(
  tabQuery: string | null,
  permissions: Partial<UserPermissions>,
): ClientProfileTabId {
  if (tabQuery && isClientProfileTabVisible(tabQuery, permissions)) {
    return tabQuery;
  }
  return 'profile';
}
